import styles from './SkipLink.module.scss';

interface SkipLinkProps {
  label: string;
  targetId: string;
}

const SkipLink = ({ label, targetId }: SkipLinkProps) => {
  return (
    <a href={`#${targetId}`} className={styles.skipLink}>
      {label}
    </a>
  );
};

export default SkipLink;
